export const PASSWORD_MIN_LENGTH = 12;

export function newPasswordError(password: string, confirmation: string): string | undefined {
  if (password.length < PASSWORD_MIN_LENGTH) {
    return `Le nouveau mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`;
  }
  if (password !== confirmation) {
    return "La confirmation du nouveau mot de passe ne correspond pas.";
  }
  return undefined;
}

export function passwordChangeError(
  currentPassword: string,
  newPassword: string,
  confirmation: string
): string | undefined {
  if (!currentPassword) return "Renseignez votre mot de passe actuel.";
  const validationError = newPasswordError(newPassword, confirmation);
  if (validationError) return validationError;
  if (currentPassword === newPassword) {
    return "Le nouveau mot de passe doit être différent du mot de passe actuel.";
  }
  return undefined;
}
